import LayoutContainer from 'components/layout/LayoutContainer';
import React, { useState, useEffect, useCallback } from 'react';
import AdminHeader from 'components/header';
import { Col, Row, Modal } from 'react-bootstrap';
import { AiOutlineCar } from 'react-icons/ai';
import Card from 'components/inputs/Card';
import { BsSearch } from 'react-icons/bs';
import Button from 'components/inputs/Button';
import * as _ from 'lodash';
import { FETCH_VEHICLE, DOWNLOAD_EXCEL_VEHICLE } from 'actions/vehicle';
import { useSelector, useDispatch } from 'react-redux';
import SearchBox from 'components/general/SearchBox';
// import { startsWith } from 'components/common/utils';
import { DELETE_VEHICLE } from 'actions/vehicle';
import PropTypes from 'prop-types';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
// import moment from 'moment';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';
import { BsDownload } from 'react-icons/bs';
import fileDownload from 'js-file-download';
import Select from 'components/inputs/Select';

const VehicleList = () => {
  const [searchText, setSearchText] = useState('');
  const [currentTab, setCurrentTab] = useState('totalVehicles');
  // const [allVehiclesData, setAllVehiclesData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [vehicleId, setVehicleId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [selectedOption, setSelectedOption] = useState('excel');
  const reportFormats = [
    { label: 'PDF Format', value: 'pdf' },
    { label: 'Excel Sheet', value: 'excel' },
  ];

  const dispatch = useDispatch();
  const allVehicles = useSelector((state) => state.vehicle.vehicles);
  const page = useSelector((state) => state.vehicle.page);
  const totalData = useSelector((state) => state.vehicle.total);
  const limit = useSelector((state) => state.vehicle.limit);
  const totalPages = useSelector((state) => state.vehicle.totalPages);

  const getVehicle = useCallback(
    (data) => {
      if (searchText) {
        const vehicleData = {
          ...data,
          search: searchText,
        };
        dispatch({ type: FETCH_VEHICLE, payload: vehicleData });
      } else {
        dispatch({ type: FETCH_VEHICLE, payload: data ? data : {} });
      }
    },
    [searchText]
  );

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setVehicleId('');
  };

  const dateFilter = useCallback(() => {
    if (sortByItem.item && sortByItem.order) {
      getSortByItem(sortByItem.item, sortByItem.order, '');
    } else if (searchText) {
      const data = {
        search: searchText,
      };
      getVehicle(data);
    } else {
      getVehicle();
    }
  }, [sortByItem, searchText]);

  const deleteVehicle = useCallback(
    () =>
      dispatch({
        type: DELETE_VEHICLE,
        payload: vehicleId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getVehicle({ page });
          }
        },
      }),
    [vehicleId]
  );

  const downloadExcelVehicle = useCallback(() => {
    if (searchText) {
      const data = {
        // excel: true,
        reportFormat: selectedOption,
        search: searchText,
      };
      dispatch({
        type: DOWNLOAD_EXCEL_VEHICLE,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              fileDownload(res.data, `Vehicle Data.${data.reportFormat === 'excel' ? 'xlsx' : 'pdf'}`);
            }
          }
        },
      });
    } else {
      const data = {
        // excel: true,
        reportFormat: selectedOption,
      };
      dispatch({
        type: DOWNLOAD_EXCEL_VEHICLE,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              fileDownload(res.data, `Vehicle Data.${data.reportFormat === 'excel' ? 'xlsx' : 'pdf'}`);
            }
          }
        },
      });
    }
  }, [selectedOption, searchText]);

  const downloadFile = () => {
    downloadExcelVehicle();
  };

  // useEffect(() => {
  //   setAllVehiclesData(
  //     _.filter(
  //       allVehicles,
  //       (item) =>
  //         startsWith(_.get(item, 'make', ''), searchText) ||
  //         startsWith(_.get(item, 'model', ''), searchText) ||
  //         startsWith(_.get(item, 'RFID', ''), searchText) ||
  //         startsWith(moment(_.get(item, 'insurance_expiry')).format('ddd, ll'), searchText)
  //     )
  //   );
  // }, [searchText, allVehicles]);

  useEffect(() => {
    getVehicle();
  }, []);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else if (searchText) {
        const data = {
          search: searchText,
          page: page.selected + 1,
        };
        getVehicle(data);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getVehicle(data);
      }
    },
    [sortByItem, searchText]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getVehicle(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getVehicle(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  return (
    <React.Fragment>
      <LayoutContainer>
        <AdminHeader title={'Vehicle Management'} />
        <div className="page-content-wrapper scrollable">
          <div className="vehicle-management-page_main">
            <div className="vehicle-management-card-block"></div>
            <div className="vehicle-list-main-block">
              <Card>
                {currentTab === 'totalVehicles' && (
                  <div className="vehicle-list-block">
                    <div className="vehicle-search-box">
                      <Row>
                        <Col xl={2}>
                          <div
                            className={`vehicle-card-block ${currentTab === 'totalVehicles' ? 'active' : ''}`}
                            onClick={() => setCurrentTab('totalVehicles')}
                          >
                            <VehicleCard key="total-vehicles" icon={<AiOutlineCar />} title={totalData} subTitle="Total Vehicles" />
                          </div>
                        </Col>
                        <Col xl={4} md={'auto'}>
                          <SearchBox preIcon={<BsSearch />} value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                        </Col>
                        <Col xl={'auto'} md={'auto'}>
                          <div className="report-search-box" onClick={dateFilter}>
                            <Button className="report-search-button">{'Search'}</Button>
                          </div>
                        </Col>
                        {/* <Col xl={'auto'} md={'auto'}>
                          <Button className="add-vehicle-btn" onClick={() => history.push('/addVehicle')}>
                            Add Vehicle
                          </Button>
                        </Col> */}
                        <Col xl={2} md={'auto'}>
                          <Select
                            options={reportFormats}
                            value={selectedOption}
                            onChange={(value) => setSelectedOption(value)}
                            placeholder="Select Report Format"
                          />
                        </Col>
                        <Col xl={'auto'} md={'auto'} className="excel-icon--block" onClick={downloadFile}>
                          <div className="vehicle-excel-icon">
                            <BsDownload size={28} color={'#3c7cdd'} />
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="vehicle-list-table">
                      <div className="table-responsive">
                        <table className="record-list-table">
                          <thead>
                            <tr>
                              <th>
                                <div className="sorting">
                                  <span>Sr no.</span>
                                </div>
                              </th>
                              <th>
                                <div className="sorting">
                                  <span>Brand (Model)</span>
                                  <span className="ico" onClick={() => handleSorting('make', sortByItem)}>
                                    <BiSort size={15} />
                                  </span>
                                </div>
                              </th>
                              <th>
                                <div className="sorting">
                                  <span>Plate Number</span>
                                  <span className="ico" onClick={() => handleSorting('plateNumber', sortByItem)}>
                                    <BiSort size={15} />
                                  </span>
                                </div>
                              </th>
                              <th>
                                <div className="sorting">
                                  <span>Vehicle Registration No.</span>
                                  <span className="ico" onClick={() => handleSorting('rto_no', sortByItem)}>
                                    <BiSort size={15} />
                                  </span>
                                </div>
                              </th>
                              <th>
                                <div>
                                  <span>Auto Charge Enabled</span>
                                </div>
                              </th>
                              {/* <th>
                                <div>
                                  <span>Action</span>
                                </div>
                              </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {_.isEmpty(allVehicles) ? (
                              <tr>
                                <td colSpan={8} className="border-0">
                                  <div className="empty-data-block">No vehicles</div>
                                </td>
                              </tr>
                            ) : (
                              _.map(_.filter(allVehicles, { ownership_type: 'b2b' }), (vehicle, index) => {
                                return (
                                  <tr key={`vehicle-data-item-${index}`}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {_.get(vehicle, 'make', '')} ({_.get(vehicle, 'model', '')})
                                    </td>
                                    <td>{_.get(vehicle, 'plateNumber', '-')}</td>
                                    <td>{_.get(vehicle, 'vin_num', '-')}</td>
                                    <td>{vehicle?.is_auto_charge_enabled ? 'Yes' : 'No'}</td>
                                    {/* <td>
                                      <div key={`action-${index}`} className="vehicle-list">
                                        <span className="list-icon">
                                          <DropDown
                                            popupClass="bottom-left"
                                            trigger={
                                              <div className={'more-info'}>
                                                <BsThreeDots />
                                              </div>
                                            }
                                          >
                                            <ul>
                                              <li className="item" onClick={() => history.push(`/editVehicle/${vehicle.id}`)}>
                                                Edit
                                              </li>
                                              <li
                                                className="item"
                                                onClick={() => {
                                                  setShowDeleteModal(true);
                                                  setVehicleId(_.get(vehicle, 'id', ''));
                                                }}
                                              >
                                                Delete
                                              </li>
                                            </ul>
                                          </DropDown>
                                        </span>
                                      </div>
                                    </td> */}
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {!_.isEmpty(allVehicles) && (
                      // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                      <ReactPagination
                        currentPage={page}
                        limit={limit}
                        total={totalData}
                        handlePageClick={(pageVal) => handlePageClick(pageVal)}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}
                      />
                    )}
                    {showDeleteModal && (
                      <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
                        <DeleteModal title="vehicle" onClose={handleCloseDeleteModel} onRemove={deleteVehicle} />
                      </Modal>
                    )}
                  </div>
                )}
                {currentTab === 'chargingVehicles' && <div className="d-flex align-items-center justify-content-center">Pending...</div>}
                {currentTab === 'finishedCharging' && <div className="d-flex align-items-center justify-content-center">Pending...</div>}
                {currentTab === 'vehiclesProblems' && <div className="d-flex align-items-center justify-content-center">Pending...</div>}
              </Card>
            </div>
          </div>
        </div>
      </LayoutContainer>
    </React.Fragment>
  );
};

export default VehicleList;

export const VehicleCard = (props) => {
  const { icon, title, subTitle, metaIcon } = props;

  return (
    <Card className="vehicle-card">
      <div className="vehicle-detail-box">
        <div className="vehicle-icon">
          <div className="car-icon">{icon}</div>
          <div className="vehicle-status-icon">{metaIcon}</div>
        </div>
        <div className="vehicle__count-info">
          <div className="total-vehicle">{title}</div>
          <div className="info-text">{subTitle}</div>
        </div>
      </div>
    </Card>
  );
};

VehicleCard.propTypes = {
  /**
   * Card icon
   */
  icon: PropTypes.node,
  /**meta icon */
  metaIcon: PropTypes.node,
  /**
   * Vehicle title
   */
  title: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Vehical sub-title
   */
  subTitle: PropTypes.string,
};
